import { render, staticRenderFns } from "./AdminVariantCharacterGroupHeader.module.vue?vue&type=template&id=2cc175d0&"
import script from "./AdminVariantCharacterGroupHeader.module.vue?vue&type=script&lang=js&"
export * from "./AdminVariantCharacterGroupHeader.module.vue?vue&type=script&lang=js&"
import style0 from "./AdminVariantCharacterGroupHeader.module.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports